export default "__VITE_ASSET__D4h54GOs__"